<style lang="less" scoped>
  @import "../../../style/theme.less";

</style>

<template>
  <div>
    <a-page-header title="Archetypes" style="padding: 0; margin-bottom: 8px">
      <template slot="extra">
        <a-button type="primary" shape="circle" icon="plus" @click="() => setShowCreateReportTypeModal(true)"/>
        <a-button type="primary" shape="circle" icon="reload" @click="listReportTypes"/>
      </template>
    </a-page-header>

    <a-row :gutter="[16,16]">
      <a-col :span="8" v-for="reportTypeCategory in ['god', 'goddess', 'divinity']" :key="reportTypeCategory">
        <a-page-header
          style="padding: 0; font-size: 14px !important;"
          :title="{ god: 'Gods', goddess: 'Goddesses', divinity: 'Divinities'}[reportTypeCategory]"
        />
        <a-table
          :columns="columns"
          :data-source="reportTypes.filter(({ type }) => type === reportTypeCategory)"
          :pagination="false"
          :rowKey="({ id }) => id"
          @change="listReportTypes"
        >

          <span slot="timestamp" slot-scope="data">{{ data | timestamp }}</span>

          <span slot="actions" slot-scope="record">
            <a-button
              type="primary"
              shape="circle"
              icon="setting"
              @click="() => $router.push({ name: 'admin.report-types.details', params: { id: record.id }})"
            />

            <a-divider type="vertical" />

            <a-popconfirm title="Are you sure you want to delete this archetype?" @confirm="() => removeReportType(record.id)">
              <a-button type="primary" shape="circle" icon="delete"/>
            </a-popconfirm>
          </span>
        </a-table>
      </a-col>
    </a-row>

    <create-report-type-modal />
  </div>
</template>

<script>

import { mapState, mapActions, mapMutations } from 'vuex';

import createReportTypeModal from './_create-report-type-modal';

const columns = [
  {
    title: 'Name',
    dataIndex: 'descriptor',
    defaultSortOrder: 'ascend',
    sorter: ({ descriptor: a, }, { descriptor: b, }) => a.localeCompare(b),
    sortDirections: ['descend', 'ascend',],
  }, {
    width: '140px',
    align: 'center',
    scopedSlots: { customRender: 'actions', },
  },
];

export default {
  name: 'admin.report-types',

  data: () => ({
    columns,
  }),

  components: {
    createReportTypeModal,
  },

  mounted() {
    return this.listReportTypes();
  },

  computed: {
    ...mapState('admin', ['reportTypes',]),
  },

  methods: {
    ...mapActions('admin', ['listReportTypes', 'removeReportType',]),
    ...mapMutations('admin', ['setShowCreateReportTypeModal',]),
  },
};
</script>
